import {View, StyleSheet, PixelRatio} from 'react-native';
import AVText from 'src/components/elements/AVText';
import {ButtonType} from 'src/components/elements/RoundedButton';
import {
  ProductCategorySearchDescriberData,
  ScanDiscountCodeStylesDescriptor,
} from 'src/components/screens/cart/descriptor/Descriptor';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

export function getDoneButtonColor(): string {
  return Styles.primaryColor;
}
export function getReportButtonColor() {
  return null;
}
export function getReportButtonType() {
  return ButtonType.outline;
}

export function getReceiptStyles() {
  return {
    amount: {
      color: Styles.darkColor,
      fontSize: getLayoutDescriber().bodyFontSize(),
    },
    bold: {
      fontWeight: 'bold',
    },
    desc: {
      color: Styles.darkColor,
      flex: 1,
      fontSize: getLayoutDescriber().bodyFontSize(),
    },
    header: {
      flex: 1,
      paddingBottom: Styles.Spacing.m3,
    },
    button: {
      marginTop: Styles.Spacing.m4,
    },
    dashStyle: {
      borderRadius: 100,
      height: PixelRatio.roundToNearestPixel(2),
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      overflow: 'hidden',
      width: '100%',
    },
    discount: {
      color: Styles.positiveColor,
    },
    supFeeStyle: {
      color: Styles.positiveColor,
    },
    labelStyle: {
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.robotoRegular,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      paddingVertical: 2,
    },
    totalLabel: {
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.robotoRegular,
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '700',
    },
    remainingBalanceLabel: {
      color: Styles.lightGray,
      fontFamily: Styles.FontFamily.robotoRegular,
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '400',
    },
    canteenRow: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  };
}

export function getProductSearchEmptyContent(
  isloading?: boolean,
  isEmpty?: number,
): JSX.Element {
  return (
    isloading &&
    isEmpty === 0 && (
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: Styles.Spacing.m6,
          marginHorizontal: Styles.Spacing.m3,
        }}
      >
        <AVText
          accessibilityRole="text"
          style={{
            fontSize: getLayoutDescriber().bodyFontSize(),
            fontWeight: '400',
            fontFamily: Styles.FontFamily.aeonikRegular,
            textAlign: 'center',
            color: '#000',
          }}
        >
          {Localized.Labels.no_products_available}
        </AVText>
      </View>
    )
  );
}
export function searchTopContainerDescriptor(): {
  [index: string]: number | string;
} {
  return {top: -30};
}

export function getSelectedProductCategoryNameContent(
  props: ProductCategorySearchDescriberData,
): JSX.Element {
  return (
    <View style={props.styles.banner}>
      <AVText style={props.styles.bannerText}>{props.category}</AVText>
    </View>
  );
}
export function productCategoryflatListStyleDescriptor(
  props: ProductCategorySearchDescriberData,
): {
  [index: string]: number | string;
} {
  return props.styles.list;
}
export function getScanDiscountStyles(): ScanDiscountCodeStylesDescriptor {
  return StyleSheet.create({
    descriptionText: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m3,
      marginHorizontal: Styles.Spacing.m3,
      color: Styles.Colors.PayNew.black01,
      fontFamily: Styles.FontFamily.aeonikRegular,
      marginBottom: Styles.Spacing.m4,
    },
  });
}
export function getManualEntryButton() {
  return null;
}
export function getColorForCheckoutButton() {
  return '#003349';
}

export default {
  getDoneButtonColor,
  getReportButtonColor,
  getReportButtonType,
  getReceiptStyles,
  getProductSearchEmptyContent,
  searchTopContainerDescriptor,
  getSelectedProductCategoryNameContent,
  productCategoryflatListStyleDescriptor,
  getScanDiscountStyles,
  getManualEntryButton,
  getColorForCheckoutButton,
};
